import { toast } from "qw-ui-lib-v2";
import { qwCinemas } from "../../app/clients/qwCinemas";
import { store } from "../../app/store/store";
import { logout } from "./authSlice";

const DEV_SESSION_KEY = "DEV_ONLY_SESSION_QWC_ADMIN";
let isLoading = false;

export const authenticateUser = async () => {
  let data = { accessToken: null };
  if (isLoading) return;
  isLoading = true;
  if (process.env.NODE_ENV !== "production") {
    // This code will be removed from the production build by webpack.
    let token = new URLSearchParams(window.location.hash).get("#access_token");
    if (token) {
      document.cookie = `${DEV_SESSION_KEY}=${token}; path=/; max-age=${24 * 60 * 60}`;
    } else {
      token = document.cookie
        .split(";")
        .find((cookie) => cookie.trim().startsWith(DEV_SESSION_KEY))
        ?.split("=")[1];
    }
    data = { accessToken: token };
  }
  try {
    const response = await qwCinemas.get(
      "/users/me",
      data.accessToken ? { headers: { Authorization: `Bearer ${data.accessToken}` } } : undefined,
    );
    data = response.data;
  } catch (e) {
    window.location.href = process.env.HOME_PAGE_URL;
  }
  isLoading = false;
  return data;
};

export const logoutUser = async () => {
  if (process.env.NODE_ENV !== "production") {
    document.cookie = `${DEV_SESSION_KEY}=; path=/; max-age=0`;
  }
  try {
    await qwCinemas.delete("/sign_out?client=admin");
    store.dispatch(logout());
  } catch (e) {
    toast.add({
      message: "Failed to log out. Please try again.",
      variant: "negative",
    });
  }
};
